export default "__VITE_ASSET__DgcQ7$$N__"